import React from 'react'
import env from './../../../environments/environment'
import Star from './../../../assets/images/svg/gold-star-vector.svg'
import Ribbon from './../../../assets/images/svg/red-gold-ribbon-vector.svg'
import { getHeadshot, autoLogin, getAgentAccessToHeadshot } from './../../../shared/utilities/getHeadshot.function'
import SystemSettingStore from './../../../shared/stores/systemSetting.store'
import './profileImage.scss'
import { useBreakTheBarSetting } from '../../../components/shared/useBreakTheBarSetting'

function determineAgentScope(agentScope) {
  if (['sig_agent', 'career_agent', 'elite_agency_team', 'division', 'region', 'district'].includes(agentScope))
    return agentScope
  return
}

function meetsUsertypeRequirement(usertypeId) {
  const restrictedUsertypes = [111, 133, 223, 224]
  return restrictedUsertypes.indexOf(parseInt(usertypeId)) < 0
}

function renderBestWeekRibbon(bestWeek) {
  if (bestWeek)
    return (
      <div className='bonus-indicator'>
        <img src={Ribbon} alt='' />
        <div>Personal Best!</div>
      </div>
    )
}

function renderBarBreaker(firstToBreakBar) {
  if (firstToBreakBar)
    return (
      <div className='bonus-indicator'>
        <img src={Star} alt='' />
        <div>1st Bar Breaker!</div>
      </div>
    )
}

function renderHeadshot(agent) {
  const { agentPic, agentName, agentId, agentScope, usertypeId, isConfQualified } = agent

  let badge = null
  if (agentScope === 'career_agent' && [90, 38, 93].includes(parseInt(usertypeId)))
    badge = `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Fbadge.sig-agent.png?alt=media`

  return (
    <div
      className={
        (agentId && getAgentAccessToHeadshot(agentId) ? 'profile-img-wrapper cursor-pointer' : 'profile-img-wrapper') +
        (isConfQualified ? ' qualified' : '')
      }
      onClick={() => {
        if (agentId && getAgentAccessToHeadshot(agentId)) autoLogin(agentId)
      }}
    >
      {badge ? (
        <div className='sig-agent-badge' alt='Signature Agent'>
          <img src={badge} />
        </div>
      ) : (
        <></>
      )}
      <img src={agentPic} alt={agentName} className='mx-auto d-block leaderboard-profile-img' />
    </div>
  )
}

function renderHeadshotWithName(agent) {
  const { agentPic, agentName, agentId, isConfQualified } = agent
  return (
    <div className='profile-container'>
      <div className='img-wrapper'>
        <div
          className={
            (agentId && getAgentAccessToHeadshot(agentId)
              ? 'profile-img-wrapper cursor-pointer'
              : 'profile-img-wrapper') + (isConfQualified ? ' qualified' : '')
          }
          onClick={() => {
            if (agentId && getAgentAccessToHeadshot(agentId)) autoLogin(agentId)
          }}
        >
          <img src={agentPic} alt={agentName} className='mx-auto d-block leaderboard-profile-img' />
        </div>
      </div>
      <div className='identity-wrapper'>
        <p className='text-center'>{agentName}</p>
        {isConfQualified ? <div className='qualified-label'>USABG Conf Qualifier</div> : null}
      </div>
    </div>
  )
}

export const ProfileImage = ({
  usertypeId,
  agentName,
  agentPic,
  mustBreakBar,
  totalPoints,
  firstToBreakBar,
  bestWeek,
  agentId,
  agentScope,
  isConfQualified,
}) => {
  // get the threshold to evaluate agent performance against.
  const { threshold } = useBreakTheBarSetting(agentScope)

  // Ensure agentName is always a string (safety check)
  const safeAgentName = typeof agentName === 'string' ? agentName : String(agentName || '')

  // ensure agent profile meets minimum requirements.
  if (!meetsUsertypeRequirement(usertypeId)) return <p className='text-center'>{safeAgentName}</p>

  // if this headshot isn't being controlled by points,
  // we can activated it now..
  if (!mustBreakBar)
    return renderHeadshotWithName({
      agentPic: getHeadshot({ u_picture: agentPic, id: agentId }),
      agentName: safeAgentName,
      agentId,
      agentScope,
      usertypeId,
      isConfQualified,
    })

  // ensure agent scope is available to be used for
  // determining the applicable BTB points thresholds.
  agentScope = determineAgentScope(agentScope)
  if (!agentScope) return <p className='text-center'>{safeAgentName}</p>

  let img

  if (
    totalPoints &&
    totalPoints >= (threshold || SystemSettingStore.get('usertypes---break-the-bar-thresholds')[agentScope]?.current)
  )
    img = renderHeadshot({
      agentPic: getHeadshot({ u_picture: agentPic, id: agentId }),
      agentName: safeAgentName,
      agentId,
      agentScope,
      usertypeId,
      isConfQualified,
    })

  return (
    <div className='profile-container'>
      <div className='img-wrapper'>
        <div>{img}</div>
      </div>
      <div className='identity-wrapper'>
        {renderBestWeekRibbon(bestWeek)}
        <p className='text-center'>{safeAgentName}</p>
        {renderBarBreaker(firstToBreakBar)}
        {isConfQualified ? <div className='qualified-label'>USABG Conf Qualifier</div> : null}
      </div>
    </div>
  )
}
